var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{staticClass:"x-grid",attrs:{"gtc-fill":"30px"}},_vm._l((_vm.dotNum),function(i){return _c('icon',{key:i,staticClass:"x-circle",style:(_vm.styles(i)),attrs:{"icon":"ExitFormCircle"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }